const COLUMNS = [
  {
    Header: 'Branch Name',
    accessor: 'BranchName',
    className: 'notranslate'
  },
  {
    Header: 'Uploaded By',
    accessor: 'UploadedBy',
    className: 'notranslate'
  },
  {
    Header: 'Upload Date & Time',
    accessor: 'UploadedDateTime',
    className: 'notranslate'
  },
  {
    Header: 'Source System',
    accessor: 'SourceSystem',
    className: 'notranslate'
  },
  {
    Header: 'Summary',
    accessor: 'Summary',
    disableSortBy: true
  },
  {
    Header: 'Status',
    accessor: 'Status',
    disableSortBy: true
  },
  {
    Header: '',
    accessor: 'DetailPage',
    disableSortBy: true
  }
];

export default COLUMNS;
